<template>
  <v-overlay :value="model">
    <v-sheet
      elevation="12"
      max-width="600"
      rounded="lg"
      width="100%"
      class="pa-4 text-center mx-auto"
      light
    >
      <v-icon class="mb-5" color="success" size="112">mdi-check-circle</v-icon>

      <h2 class="text-h5 mb-6">
        {{ $t("pages.category_menu.sentence_5") }}
      </h2>

      <p class="mb-4 text-medium-emphasis text-body-2">
        {{ $t("pages.category_menu.sentence_9") }}
      </p>

      <div v-if="log && log.success && log.success.length" class="success--text">
        Success ({{ log.success.length }}):
        <div v-if="log.success.length">
          <template v-for="item in log.success">
            <div>{{ item.food.name }}</div>
          </template>
        </div>
      </div>
      <div v-if="log && log.failed && log.failed.length" class="error--text">
        Failed ({{ log.failed.length }}):
        <template v-for="item in log.failed">
          <div>{{ item.food.name }}</div>
        </template>
      </div>

      <v-divider class="mb-4"></v-divider>

      <div class="text-end">
        <primary-button @click="model = false" block>
          {{ $t("pages.category_menu.sentence_6") }}({{ timeleft }})
        </primary-button>
      </div>
    </v-sheet>
  </v-overlay>
</template>

<script>
import hasModel from "@/mixins/hasModel";

export default {
  name: "CategoryMenuOverlay",
  mixins: [hasModel],
  props: {
    log: {
      type: Object,
      default: () => ({}),
    },
    timeleft: {
      type: Number,
      default: 0,
    },
  },
  computed: {},
};
</script>
